declare namespace $ {

	export class $shm_hitalama_textbook_tree extends $shm_tree {
	}
	
}

//# sourceMappingURL=tree.view.tree.d.ts.map